import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

type UppercaseInputElement = HTMLInputElement | HTMLTextAreaElement;

@Directive({
  selector: '[appUppercase]',
})
export class UppercaseInputDirective {
  private isSyncing = false;

  constructor(
    private readonly elementRef: ElementRef<UppercaseInputElement>,
    @Optional() private readonly ngControl: NgControl | null,
  ) { }

  @HostListener('input', ['$event'])
  handleInput(event: Event): void {
    // Avoid breaking IME composition.
    if ((event as InputEvent).isComposing) return;
    this.normalizeValue();
  }

  @HostListener('blur')
  handleBlur(): void {
    this.normalizeValue();
  }

  private normalizeValue(): void {
    if (this.isSyncing) return;

    const el = this.elementRef.nativeElement;
    const rawValue = el.value;
    if (!rawValue) return;

    const nextValue = rawValue.toUpperCase();
    if (nextValue === rawValue) return;

    // Preserve cursor position: `toUpperCase()` should not change string length for our use-cases.
    const start = el.selectionStart ?? 0;
    const end = el.selectionEnd ?? start;

    this.isSyncing = true;
    el.value = nextValue;
    try {
      el.setSelectionRange(start, end);
    } catch {
      // Best-effort only.
    }

    // Keep the reactive form control in sync.
    const control = this.ngControl?.control;
    if (control) {
      control.setValue(nextValue, { emitEvent: false, emitModelToViewChange: false });
    }

    this.isSyncing = false;
  }
}

